import localforage from "localforage";

const AUTH_SESSION_KEY = "offline_auth_session";

export type OfflineAuthSession = {
    token: string | null;
    user: any;
    roles: any[];
    organizations: any[];
    selectedOrganizationId: string | null;
    savedAt: number;
};

const authStore = localforage.createInstance({
    name: "colorado-roofing",
    storeName: "offline_auth",
});

export async function saveAuthSession(
    session: Omit<OfflineAuthSession, "savedAt">,
): Promise<void> {
    await authStore.setItem(AUTH_SESSION_KEY, {
        ...session,
        savedAt: Date.now(),
    } satisfies OfflineAuthSession);
}

export async function loadAuthSession(): Promise<OfflineAuthSession | null> {
    const session = await authStore.getItem<OfflineAuthSession>(AUTH_SESSION_KEY);
    return session || null;
}

export async function clearAuthSession(): Promise<void> {
    await authStore.removeItem(AUTH_SESSION_KEY);
}
